import { CampaignUSPs } from "@forwardflow/components/Campaign/CampaignUSP";

const CampaignUSP = () => {
   return (
      <>
         <CampaignUSPs />
      </>
   );
};

export default CampaignUSP;
